import {
  clientFilter,
  locationFilter,
  materialsFilter,
  pagination,
  projectFilter,
  servicesFilter,
  ticketFilter,
  turbineFilter,
  userManagementFilter,
} from "./filter";

export const routeNames = {
  DASHBOARD: "dashboard",
  USER_LOGIN: "login",
  USER_LOGOUT: "logout",
  USER_ONBOARDING: "login.onboarding",
  USER_SET_PASSWORD: "login.set_password",
  USER_FORGOT_PASSWORD: "login.forgot_password",
  USER_CURRENT: "me",
  TICKETS: "tickets",
  TICKET_LIST: "tickets.list",
  TICKET_CREATE: "tickets.new",
  TICKET_EDIT: "tickets.edit",
  TICKET_VIEW: "tickets.view",
  CLIENTS: "clients",
  CLIENT_LIST: "clients.list",
  CLIENT_CREATE: "clients.new",
  CLIENT_EDIT: "clients.edit",
  CLIENT_VIEW: "clients.view",
  TURBINES: "turbines",
  TURBINE_LIST: "turbines.list",
  TURBINE_CREATE: "turbines.new",
  TURBINE_EDIT: "turbines.edit",
  TURBINE_VIEW: "turbines.view",
  LOCATIONS: "locations",
  LOCATION_LIST: "locations.list",
  LOCATION_CREATE: "locations.new",
  LOCATION_EDIT: "locations.edit",
  LOCATION_VIEW: "locations.view",
  PROJECTS: "projects",
  PROJECT_LIST: "projects.list",
  PROJECT_CREATE: "projects.new",
  PROJECT_EDIT: "projects.edit",
  PROJECT_VIEW: "projects.view",
  SETTINGS: "settings",
  SETTINGS_USERS: "settings.users",
  SETTINGS_USER_LIST: "settings.users.list",
  SETTINGS_USER_CREATE: "settings.users.new",
  SETTINGS_USER_EDIT: "settings.users.edit",
  SETTINGS_MATERIALS: "settings.materials",
  SETTINGS_MATERIAL_LIST: "settings.materials.list",
  SETTINGS_MATERIAL_CREATE: "settings.materials.new",
  SETTINGS_MATERIAL_EDIT: "settings.materials.edit",
  USERS: "users",
  USER_PROFILE_VIEW: "users.view",
  USER_PROFILE_EDIT: "users.edit",
  SETTINGS_SERVICES: "settings.services",
  SETTINGS_SERVICE_LIST: "settings.services.list",
  SETTINGS_SERVICE_CREATE: "settings.services.new",
  SETTINGS_SERVICE_EDIT: "settings.services.edit",
  SETTINGS_SERVICE_VIEW: "settings.services.view",
  NOTIFICATIONS: "notifications",
};

export const publicRoutes = {
  [routeNames.USER_LOGIN]: true,
  [routeNames.USER_LOGOUT]: true,
  [routeNames.USER_ONBOARDING]: true,
  [routeNames.USER_SET_PASSWORD]: true,
  [routeNames.USER_FORGOT_PASSWORD]: true,
};

export const routes = [
  {
    name: routeNames.DASHBOARD,
    path: "/",
  },
  {
    name: routeNames.TICKETS,
    path: "/tickets",
  },
  {
    name: routeNames.TICKET_LIST,
    path: `/l?${Object.keys(ticketFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.USER_LOGIN,
    path: "/login",
  },
  {
    name: routeNames.USER_ONBOARDING,
    path: "/get_mfa_key/?:secret",
  },
  {
    name: routeNames.USER_SET_PASSWORD,
    path: "/set_password/?:secret",
  },
  {
    name: routeNames.USER_FORGOT_PASSWORD,
    path: "/forgot_password",
  },
  {
    name: routeNames.USER_LOGOUT,
    path: "/logout",
  },
  {
    name: routeNames.USER_CURRENT,
    path: "/me",
  },
  {
    name: routeNames.TICKET_CREATE,
    path: "/new",
  },
  {
    name: routeNames.TICKET_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.TICKET_VIEW,
    path: "/view/:id?:section&:taskId",
  },
  {
    name: routeNames.CLIENTS,
    path: "/clients",
  },
  {
    name: routeNames.CLIENT_LIST,
    path: `/l?${Object.keys(clientFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.CLIENT_CREATE,
    path: "/new",
  },
  {
    name: routeNames.CLIENT_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.CLIENT_VIEW,
    path: "/view/:id",
  },
  {
    name: routeNames.TURBINES,
    path: "/turbines",
  },
  {
    name: routeNames.TURBINE_LIST,
    path: `/l?${Object.keys(turbineFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.TURBINE_CREATE,
    path: "/new",
  },
  {
    name: routeNames.TURBINE_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.TURBINE_VIEW,
    path: "/view/:id",
  },
  {
    name: routeNames.PROJECTS,
    path: "/projects",
  },
  {
    name: routeNames.PROJECT_LIST,
    path: `/l?${Object.keys(projectFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.PROJECT_CREATE,
    path: "/new",
  },
  {
    name: routeNames.PROJECT_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.PROJECT_VIEW,
    path: "/view/:id",
  },
  {
    name: routeNames.LOCATIONS,
    path: "/locations",
  },
  {
    name: routeNames.LOCATION_LIST,
    path: `/l?${Object.keys(locationFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.LOCATION_CREATE,
    path: "/new",
  },
  {
    name: routeNames.LOCATION_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.LOCATION_VIEW,
    path: "/view/:id",
  },
  {
    name: routeNames.USERS,
    path: "/users",
  },
  {
    name: routeNames.USER_PROFILE_VIEW,
    path: "/view/:id",
  },
  {
    name: routeNames.USER_PROFILE_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.SETTINGS,
    path: "/settings",
  },
  {
    name: routeNames.SETTINGS_USERS,
    path: "/users",
  },
  {
    name: routeNames.SETTINGS_USER_LIST,
    path: `/l?${Object.keys(userManagementFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.SETTINGS_USER_CREATE,
    path: "/new",
  },
  {
    name: routeNames.SETTINGS_USER_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.SETTINGS_MATERIALS,
    path: "/materials",
  },
  {
    name: routeNames.SETTINGS_MATERIAL_LIST,
    path: `/l?${Object.keys(materialsFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.SETTINGS_MATERIAL_CREATE,
    path: "/new",
  },
  {
    name: routeNames.SETTINGS_MATERIAL_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.SETTINGS_SERVICES,
    path: "/services",
  },
  {
    name: routeNames.SETTINGS_SERVICE_LIST,
    path: `/l?${Object.keys(servicesFilter)
      .concat(Object.keys(pagination))
      .map((filterParam) => `:${filterParam}`)
      .join("&")}`,
  },
  {
    name: routeNames.SETTINGS_SERVICE_CREATE,
    path: "/new",
  },
  {
    name: routeNames.SETTINGS_SERVICE_EDIT,
    path: "/edit/:id",
  },
  {
    name: routeNames.SETTINGS_SERVICE_VIEW,
    path: "/view/:id",
  },
  {
    name: routeNames.NOTIFICATIONS,
    path: "/notifications",
  },
];
